import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-http-error-service',
  templateUrl: './http-error-service.component.html',
  styleUrls: ['./http-error-service.component.scss']
})
export class HttpErrorServiceComponent implements OnInit {

  @Output() retry = new EventEmitter<any>();
  @Input() errorMsg: string = '';

  constructor() { }

  ngOnInit() { }

}
